import type { Vector2 } from 'three';

import EventManager from './EventManager';

enum EventNames {
  ZOOM,
  DRAG_CAMERA_START,
  DRAG_CAMERA,
  ROTATION_START,
}

const camera3DEventManager = new EventManager<EventNames>();

export const Camera3DEvents = {
  DRAG_CAMERA: camera3DEventManager.createEvent(EventNames.DRAG_CAMERA),
  DRAG_CAMERA_START: camera3DEventManager.createEvent(EventNames.DRAG_CAMERA_START),
  ZOOM: camera3DEventManager.createEvent<number>(EventNames.ZOOM),
  ROTATION_START: camera3DEventManager.createEvent<{
    direction: Vector2;
  }>(EventNames.ROTATION_START),
};

export default camera3DEventManager;
